export const PIPES_CONSTANTS = {
  POLYGONS: [
    'Pipe-Polygon1',
    'Pipe-Polygon2',
    'Pipe-Polygon3',
    'Pipe-Polygon4',
    'Pipe-Polygon5',
    'Pipe-Polygon6',
    'Pipe-Polygon7',
  ],
};

export const PIPES_CONSTANTS_AMERICAN_WATER = {
  POLYGONS: [
    'Pipe-Polygon1',
    'Pipe-Polygon2',
    'Pipe-Polygon3',
    // 'Pipe-Polygon4', 'Pipe-Polygon5', 'Pipe-Polygon6', 'Pipe-Polygon7'
  ],
};
